import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { Resultado } from '../../resultado';
import { UsuarioModule } from '../modelo/usuario/usuario.module';
import { LoginService } from '../servicios/login.service';
import Keyboard from 'simple-keyboard';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {

 

  ngOnInit() {
/*
   if ( window.navigator.onLine==false){
    var mydb = openDatabase("", "0.1", "A Database of Cars I Like", 1024 * 1024);
    mydb.transaction(function (t) {
      t.executeSql("CREATE TABLE IF NOT EXISTS cars (id INTEGER PRIMARY KEY ASC, make TEXT, model TEXT)");
  });
  mydb.transaction(function (t) {
    t.executeSql("INSERT INTO cars (make, model) VALUES (?, ?)", ['sds','']);

});*/
  

    localStorage.clear();
    }
 
  resultadoDes: string;
  username: string;
  clave: string;
  data: Resultado[] = [];
  resul: Resultado[];
  id: string;
  ruc: string;
  escentroComercial: string;
  inventario: string;
  establecimiento: string;
  tipo: string;
  caja: string;
  cierre_caja:string;
  iva:number;
  title = 'appFacturacion';
  value = '';
  keyboard: Keyboard;
  constructor(private permissionsService : NgxPermissionsService ,private rolesService: NgxRolesService,private api: LoginService, private ruter: Router,private alertService: AlertService) { }


  onInputFocus() {
    this.keyboard = new Keyboard({
          onChange: input => this.onChange(input),
          onKeyPress: button => this.onKeyPress(button)
        });
    }

    DeChange(){
  
    }
    
  onChange = (input: string) => {
    this.value = input;
    console.log('Input changed', input);
  };


  onKeyPress = (button: string) => {
    console.log('Button pressed', button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') this.handleShift();
  };

  onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value);
  }

  handleShift = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };

  login() {
  
    console.log(this.username);
    this.api.validarUsuario(this.username, this.clave)
      .subscribe((
        data: Resultado[]) => {
        this.resul = data;
        if (  this.resul!=null){
          this.resul.forEach(item => {
            this.resultadoDes = item.mensaje;
            this.ruc = item.ruc;
            this.id = item.id;
            this.tipo=item.rol;
            this.cierre_caja=item.cierre_caja
            this.caja=item.caja
            this.establecimiento=item.establecimiento;
            this.escentroComercial=item.esCentroComercial
            this.inventario=item.inventario
            this.iva=Number.parseFloat(item.iva);
          });
          console.log(this.resultadoDes);
          if (this.resultadoDes === 'Correcto') {
            localStorage.setItem('ruc', this.ruc);
            localStorage.setItem('id', this.id);
            localStorage.setItem('rol',this.tipo);
            localStorage.setItem('usuario',this.username);
            localStorage.setItem('establecimiento',this.establecimiento);
            localStorage.setItem('cierre_caja',this.cierre_caja);
            localStorage.setItem('caja',this.caja);
            localStorage.setItem('escentroComercial',this.escentroComercial);
            localStorage.setItem('iva',this.iva?.toString());
            localStorage.setItem('usuario',this.username);
            localStorage.setItem('inventario',this.inventario);
           
            let rol:string [];
            rol=[];
            rol.push(localStorage.getItem('rol'));
            this.permissionsService.loadPermissions(rol);
            this.rolesService.addRole('Adminstrador', []);
            this.ruter.navigate(['dashboard']);

          } else {
            this.username=null;
            this.clave=null;
            this.alertService.warning('Usuario o clave incorrecto..');
            }
        }
      },
      err =>  this.alertService.warning('Error no hay  conexion..')
      );
  
}
}



